export const todayDateTimeString = new Date().toISOString();
export const sixtyDaysAgoDateTimeString = new Date(new Date().setDate(new Date().getDate() - 60)).toISOString();
export const sixtyDaysFromNowDateTimeString = new Date(new Date().setDate(new Date().getDate() + 60)).toISOString();
